import {styled} from '@vw-marketing/us-components';

export const ModalDisplayContainer = styled.div`
  position: fixed;
  z-index: 999;
`;
